module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/tr-subtitle.d58a9b2d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/tr-subtitle.png
// module id = 2766
// module chunks = 11